import { useNavigate, useSearchParams } from "@solidjs/router";
import { Text, View, hexColor } from "@lightningtv/solid";
import packageJson from "../../../package.json";
import { Show, For, createEffect, onMount, createSignal } from "solid-js";
import Subscriptions from "./components/Subscriptions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Account from "./components/Acoount";
import LanguagePicker from "./components/Language";
import ChangePin from "./components/ChangePin";
import { Button } from "@lightningtv/solid-ui";
import * as i18n from "@solid-primitives/i18n";
import { t } from "../../translations/configuration";
import styles from "../../styles";
import SetPin from "../../components/SetPin";
import DnsSettings from "./components/dnsSelector";
import {
  deviceModel,
  tizenVersion,
  screenResolution,
  screenSize,
  deviceDUID,
  networkType,
  manufacturer,
  deviceYear,
  storageInfo
} from "../../../state";

// The settings UI itself, usable either as a full page (see UserInfo.tsx,
// the /userInfo route) or embedded inline — e.g. under Home's header row,
// where selecting "Settings" shows this without navigating away.
const SettingsPanel = (props: { onEscape: () => void; onUp?: () => void }) => {
  let accountRef;
  let subscriptionsRef;
  let languageRef;
  let changePINRef;
  let policyRef;
  let refLanguage;
  let deviceInfoRef;
  let internetRef;
  let killSwitchMenuRef;
  let killSwitchModalCancelRef;
  let killSwitchModalOkRef;
  let killSwitchToggleRef;
  let systemDnsRef;

  createEffect(() => {
    console.log('UserInfo signals:', {
      model: deviceModel(),
      year: deviceYear(),
      tizen: tizenVersion(),
      storage: storageInfo(),
      duid: deviceDUID()
    });
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [accountFocus, setAccountFocus] = createSignal(false);
  const [subscriptionFocus, setSubscriptionFocus] = createSignal(false);
  const [languageFocus, setLanguageFocus] = createSignal(false);
  const [changePin, setChangePin] = createSignal(false);
  const [privacyPolicyFocus, setPrivacyPolicyFocus] = createSignal(false);
  const [day, setDay] = createSignal("");
  const [dateTime, setDateTime] = createSignal("");
  const [deviceInfoFocus, setDeviceInfoFocus] = createSignal(false);
  const [internetFocus, setInternetFocus] = createSignal(false);
  const [killSwitchEnabled, setKillSwitchEnabled] = createSignal(false);
  const [dnsType, setDnsType] = createSignal("system");
  const [customDns, setCustomDns] = createSignal({
    primary1: "8", primary2: "8", primary3: "8", primary4: "8",
    secondary1: "8", secondary2: "8", secondary3: "4", secondary4: "4"
  });

  const [killSwitchFocus, setKillSwitchFocus] = createSignal(false);
  const [showKillSwitchModal, setShowKillSwitchModal] = createSignal(false);
  const [pendingKillSwitchState, setPendingKillSwitchState] = createSignal(false);

  let keypad1Ref, keypad2Ref, keypad3Ref, keypad4Ref, keypad5Ref, keypad6Ref, keypad7Ref, keypad8Ref, keypad9Ref, keypad0Ref;
  let keypadDelRef, keypadEnterRef;
  let dnsInput1Ref, dnsInput2Ref, dnsInput3Ref, dnsInput4Ref;
  let dnsInput5Ref, dnsInput6Ref, dnsInput7Ref, dnsInput8Ref;

  const [currentFieldIndex, setCurrentFieldIndex] = createSignal(0);
  const fieldNames = ['primary1', 'primary2', 'primary3', 'primary4', 'secondary1', 'secondary2', 'secondary3', 'secondary4'];
  const fieldRefs = () => [dnsInput1Ref, dnsInput2Ref, dnsInput3Ref, dnsInput4Ref, dnsInput5Ref, dnsInput6Ref, dnsInput7Ref, dnsInput8Ref];

  const keyboardRef: any = {};
  const [editingField, setEditingField] = createSignal(null);
  const [inputValue, setInputValue] = createSignal("");

  const isGoogleDns = () => {
    const dns = customDns();
    return dnsType() === "custom" &&
      dns.primary1 === "8" && dns.primary2 === "8" &&
      dns.primary3 === "8" && dns.primary4 === "8" &&
      dns.secondary1 === "8" && dns.secondary2 === "8" &&
      dns.secondary3 === "4" && dns.secondary4 === "4";
  };

  const isCloudflareDns = () => {
    const dns = customDns();
    return dnsType() === "custom" &&
      dns.primary1 === "1" && dns.primary2 === "1" &&
      dns.primary3 === "1" && dns.primary4 === "1" &&
      dns.secondary1 === "1" && dns.secondary2 === "0" &&
      dns.secondary3 === "0" && dns.secondary4 === "1";
  };

  const isQuad9Dns = () => {
    const dns = customDns();
    return dnsType() === "custom" &&
      dns.primary1 === "9" && dns.primary2 === "9" &&
      dns.primary3 === "9" && dns.primary4 === "9" &&
      dns.secondary1 === "149" && dns.secondary2 === "112" &&
      dns.secondary3 === "112" && dns.secondary4 === "112";
  };

  const isCustomDnsSelected = () => {
    return dnsType() === "custom" && !isGoogleDns() && !isCloudflareDns() && !isQuad9Dns();
  };

  const saveDnsSettingsEnhanced = () => {
    const dnsSettings = {
      type: dnsType(),
      customDns: customDns()
    };
    localStorage.setItem("dnsSettings", JSON.stringify(dnsSettings));
    console.log("DNS settings saved:", dnsSettings);
    saveDnsSettings();
  };

  const startEditing = (field) => {
    console.log('uhappppp');
    setEditingField(field);
    setInputValue(customDns()[field]);
  };

  const saveField = () => {
    if (editingField()) {
      const newValue = inputValue();
      if (newValue && parseInt(newValue) >= 0 && parseInt(newValue) <= 255) {
        setCustomDns(prev => ({
          ...prev,
          [editingField()]: newValue
        }));
        setTimeout(() => {
          saveDnsSettingsEnhanced();
        }, 50);
      }
      setEditingField(null);
      setInputValue("");
    }
  };

  const cancelEditing = () => {
    setEditingField(null);
    setInputValue("");
  };

  const handleDigitInput = (digit) => {
    if (editingField()) {
      const currentValue = inputValue();
      const newValue = currentValue + digit;
      if (parseInt(newValue) <= 255) {
        setInputValue(newValue);
      }
    }
  };

  const handleBackspace = () => {
    if (editingField()) {
      setInputValue(prev => prev.slice(0, -1));
    }
  };

  const handleKeypadDigit = (digit) => {
    const currentField = fieldNames[currentFieldIndex()];
    const newValue = digit;

    if (parseInt(newValue) <= 255) {
      setCustomDns(prev => ({
        ...prev,
        [currentField]: newValue
      }));

      const nextIndex = currentFieldIndex() + 1;
      if (nextIndex < fieldNames.length) {
        setCurrentFieldIndex(nextIndex);
        setTimeout(() => {
          fieldRefs()[nextIndex]?.setFocus?.();
        }, 50);
      }

      setTimeout(() => {
        saveDnsSettingsEnhanced();
      }, 100);
    }
  };

  const handleKeypadDelete = () => {
    const currentField = fieldNames[currentFieldIndex()];

    setCustomDns(prev => ({
      ...prev,
      [currentField]: '0'
    }));

    const prevIndex = currentFieldIndex() - 1;
    if (prevIndex >= 0) {
      setCurrentFieldIndex(prevIndex);
      setTimeout(() => {
        fieldRefs()[prevIndex]?.setFocus?.();
      }, 50);
    }

    setTimeout(() => {
      saveDnsSettingsEnhanced();
    }, 100);
  };

  const selectField = (fieldIndex) => {
    setCurrentFieldIndex(fieldIndex);
    setTimeout(() => {
      keypad5Ref?.setFocus?.();
    }, 50);
  };

  const changePinKeyboardRef: any = {};
  const setPinKeyboardRef: any = {};

  const saveDnsSettings = () => {
    const dnsSettings = {
      type: dnsType(),
      customDns: customDns()
    };
    localStorage.setItem("dnsSettings", JSON.stringify(dnsSettings));
    console.log("DNS settings saved:", dnsSettings);
  };

  const loadDnsSettings = () => {
    const savedSettings = localStorage.getItem("dnsSettings");
    if (savedSettings) {
      const parsed = JSON.parse(savedSettings);
      setDnsType(parsed.type || "system");
      if (parsed.customDns) {
        setCustomDns(parsed.customDns);
      }
      console.log("DNS settings loaded:", parsed);
    }
  };

  onMount(() => {
    const paramValue = searchParams.fromPIN;
    console.log('paramvalue', paramValue);

    if (paramValue === 'true') {
      changePINRef.setFocus()
    } else {
      accountRef.setFocus();
      setAccountFocus(true);
    }
  });

  onMount(() => {
    const now = new Date();

    const savedKillSwitch = localStorage.getItem("killSwitch");
    setKillSwitchEnabled(savedKillSwitch === "enabled");

    loadDnsSettings();

    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = dayNames[now.getDay()];
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });

    setDay(dayName);
    setDateTime(`${formattedDate} | ${formattedTime}`);
  });

  const handlePinSet = () => {
    console.log("PIN changed successfully!");
    const paramValue = searchParams.fromPIN;
    console.log('paramvalue', paramValue);

    if (paramValue === 'true') {
      navigate(-1)
    } else {
      changePINRef.setFocus()
    }
  };

  return (
    <View
      color={hexColor("#000000")}
      onEscape={() => {
        // Returning true stops this Escape from also bubbling up to an
        // ancestor's onEscape — matters when this panel is embedded inside
        // another page's tree (e.g. Home's header) rather than mounted as
        // its own route.
        props.onEscape();
        return true;
      }}
      width={1920}
      height={1080}
    >
      <View y={150}>
        {/* Account */}
        <View
          x={100}
          y={20}
          onDown={() => policyRef.setFocus()}
          onUp={() => props.onUp?.()}
          onFocus={() => {
            setAccountFocus(true);
            setSubscriptionFocus(false);
            setLanguageFocus(false);
            setPrivacyPolicyFocus(false);
            setDeviceInfoFocus(false);
            setChangePin(false);
            setInternetFocus(false);
            setKillSwitchFocus(false);
          }}
          style={{
            focus: { color: hexColor("#ffffff") },
            width: 360,
            height: 70,
            borderRadius: 10,
          }}
        >
          <Text ref={el => { accountRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#000000") } }}>
            {t("account")}
          </Text>
        </View>

        {/* Subscriptions */}
        {/* <View
          x={100}
          y={80}
          onDown={() => policyRef.setFocus()}
          onUp={() => accountRef.setFocus()}
          onFocus={() => {
            setAccountFocus(false);
            setSubscriptionFocus(true);
            setLanguageFocus(false);
            setPrivacyPolicyFocus(false);
            setChangePin(false);
            setDeviceInfoFocus(false);
            setInternetFocus(false);
            setKillSwitchFocus(false);
          }}
          style={{
            focus: { color: hexColor("#ffffff") },
            width: 360,
            height: 70,
            borderRadius: 10,
          }}
        >
          <Text ref={el => { subscriptionsRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#000000") } }}>
            {t("subscriptions")}
          </Text>
        </View> */}

        {/* Privacy Policy */}
        <View
          x={100}
          y={100}
          onUp={() => accountRef.setFocus()}
          onDown={() => languageRef.setFocus()}
          onFocus={() => {
            setAccountFocus(false);
            setSubscriptionFocus(false);
            setLanguageFocus(false);
            setPrivacyPolicyFocus(true);
            setChangePin(false);
            setInternetFocus(false);
            setDeviceInfoFocus(false);
            setKillSwitchFocus(false);
          }}
          style={{
            focus: { color: hexColor("#ffffff") },
            width: 360,
            height: 70,
            borderRadius: 10,
          }}
        >
          <Text ref={el => { policyRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#000000") } }}>
            {t("privacyPilicy")}
          </Text>
        </View>

        {/* Language */}
        <View
          x={100}
          y={180}
          onUp={() => policyRef.setFocus()}
          onRight={() => refLanguage.setFocus()}
          onDown={() => changePINRef.setFocus()}
          onFocus={() => {
            setAccountFocus(false);
            setSubscriptionFocus(false);
            setLanguageFocus(true);
            setPrivacyPolicyFocus(false);
            setChangePin(false);
            setInternetFocus(false);
            setDeviceInfoFocus(false);
            setKillSwitchFocus(false);
          }}

          style={{
            focus: { color: hexColor("#ffffff") },
            width: 360,
            height: 70,
            borderRadius: 10,
          }}
        >
          <Text ref={el => { languageRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#000000") } }}>
            {t("languge")}
          </Text>
        </View>

        {/* Change PIN */}
        <View
          x={100}
          y={260}
          onUp={() => languageRef.setFocus()}
          onDown={() => killSwitchMenuRef.setFocus()}
          onRight={() => {
            if (localStorage.getItem('userPin') === null) {
              setPinKeyboardRef.setFocus?.();
            } else {
              changePinKeyboardRef.setFocus?.();
            }
          }}
          onFocus={() => {
            setAccountFocus(false);
            setSubscriptionFocus(false);
            setLanguageFocus(false);
            setPrivacyPolicyFocus(false);
            setChangePin(true);
            setInternetFocus(false);
            setDeviceInfoFocus(false);
            setKillSwitchFocus(false);
          }}
          style={{
            focus: { color: hexColor("#ffffff") },
            width: 360,
            height: 70,
            borderRadius: 10,
          }}
        >
          <Text ref={el => { changePINRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#000000") } }}>
            Change PIN
          </Text>
        </View>

        {/* Kill Switch */}
        {/* <View
          x={100}
          y={400}
          onUp={() => changePINRef.setFocus()}
          onDown={() => deviceInfoRef.setFocus()}
          onRight={() => killSwitchToggleRef.setFocus()}
          onFocus={() => {
            setAccountFocus(false);
            setSubscriptionFocus(false);
            setLanguageFocus(false);
            setPrivacyPolicyFocus(false);
            setChangePin(false);
            setInternetFocus(false);
            setDeviceInfoFocus(false);
            setKillSwitchFocus(true);
          }}
        >
          <Text ref={el => { killSwitchMenuRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#128DD3") } }}>
            Kill Switch
          </Text>
        </View> */}

        {/* Device Information */}
        {/* <View
          x={100}
          y={480}
          onUp={() => killSwitchMenuRef.setFocus()}
          onRight={() => deviceInfoRef.setFocus()}
          onFocus={() => {
            setAccountFocus(false);
            setSubscriptionFocus(false);
            setLanguageFocus(false);
            setPrivacyPolicyFocus(false);
            setChangePin(false);
            setInternetFocus(false);
            setKillSwitchFocus(false);
            setDeviceInfoFocus(true);
          }}
        >
          <Text ref={el => { deviceInfoRef = el; }} x={30} y={18}
            style={{ fontSize: 36, color: hexColor("#ffffff"), focus: { color: hexColor("#128DD3") } }}>
            Device Information
          </Text>
        </View> */}

        {/* Vertical Separator Line */}
        <View
          x={500}
          y={-20}
          style={{
            borderLeftWidth: 2,
            height: 800,
            width: 2,
            color: hexColor("#333333"),
          }}
        />

        {/* Content Area */}
        <Show when={accountFocus()}>
          <Account />
          <Subscriptions />

        </Show>
        {/* <Show when={subscriptionFocus()}>
        </Show> */}
        <Show when={privacyPolicyFocus()}>
          <PrivacyPolicy />
        </Show>
        <Show when={changePin()}>
          <Show when={localStorage.getItem('userPin') === null} fallback={
            <ChangePin
              onPinSet={handlePinSet}
              keyboardRef={changePinKeyboardRef}
              onBackLeft={() => changePINRef.setFocus?.()}
            />}
          >
            <SetPin
              onPinSet={handlePinSet}
              showSkip={false}
              showBackground={false}
              x={600}
              y={50}
              onBackLeft={() => changePINRef.setFocus?.()}
              keyboardRef={setPinKeyboardRef}
              isForFast={searchParams.fromPIN}
            />
          </Show>
        </Show>

        <Show when={internetFocus()}>
          <View x={550} y={-20} height={900} width={1300} clipping>
            <DnsSettings
              onBack={() => {
                internetRef?.setFocus?.();
              }}
              onSave={(settings) => {
                console.log("DNS settings saved:", settings);
              }}
              setSystemDnsRef={(ref) => (systemDnsRef = ref)}
            />
          </View>
        </Show>

        <Show when={showKillSwitchModal()}>
          <View
            width={1920}
            height={1080}
            positionAbsolute={0}
            style={{ zIndex: 2000 }}
          >
            <View x={460} y={240} width={1000} height={400} color={hexColor("#ffffff")} borderRadius={25}>
              <View x={50} y={40}>
                <Text x={0} y={10} style={{ fontSize: 32, color: hexColor("#000000"), fontWeight: "bold" }}>
                  {pendingKillSwitchState() ? "Enable Kill Switch?" : "Disable Kill Switch?"}
                </Text>
              </View>

              <View x={50} y={120}>
                <Text x={0} y={0} style={{ fontSize: 24, color: hexColor("#128DD3"), fontWeight: "bold" }}>
                  Extra Privacy Protection
                </Text>

                <View x={0} y={50}>
                  <Text x={0} y={0} style={{ fontSize: 20, color: hexColor("#000000") }}>
                    {pendingKillSwitchState()
                      ? "When enabled, Applay will ONLY work when Privacy Mode is turned on."
                      : "Applay will work normally with or without Privacy Mode."
                    }
                  </Text>
                  <Text x={0} y={40} style={{ fontSize: 18, color: hexColor("#666666") }}>
                    {pendingKillSwitchState()
                      ? "• If Privacy Mode is ON: you can stream content securely"
                      : "Kill Switch provides an extra layer of protection for maximum privacy."
                    }
                  </Text>
                  <Text x={0} y={70} style={{ fontSize: 18, color: hexColor("#666666") }}>
                    {pendingKillSwitchState()
                      ? "• If Privacy Mode is OFF: the app will block access to protect your privacy"
                      : "You can re-enable it anytime for maximum security."
                    }
                  </Text>
                </View>
              </View>

              <View x={300} y={290}>
                <View
                  ref={(el) => { killSwitchModalCancelRef = el; }}
                  x={0}
                  y={0}
                  style={{
                    borderRadius: 20,
                    color: hexColor("#C1C3C1"),
                    focus: { color: hexColor("#128DD3") },
                    height: 60,
                    width: 150,
                  }}
                  onRight={() => killSwitchModalOkRef.setFocus()}
                  onEnter={() => {
                    setShowKillSwitchModal(false);
                    killSwitchToggleRef.setFocus();
                  }}
                >
                  <Text x={30} y={20} style={{ fontSize: 24, color: hexColor("#ffffff"), fontWeight: "bold" }}>
                    Cancel
                  </Text>
                </View>

                <View
                  ref={(el) => { killSwitchModalOkRef = el; }}
                  x={200}
                  y={0}
                  style={{
                    borderRadius: 20,
                    color: hexColor("#808080"),
                    focus: {
                      color: pendingKillSwitchState() ? hexColor("#00cc00") : hexColor("#ff4444"),
                    },
                    transition: { scale: { duration: 250, easing: "ease-in-out" } },
                    height: 60,
                    width: 150,
                  }}
                  onLeft={() => killSwitchModalCancelRef.setFocus()}
                  onEnter={() => {
                    const newState = pendingKillSwitchState();
                    setKillSwitchEnabled(newState);
                    localStorage.setItem("killSwitch", newState ? "enabled" : "disabled");
                    console.log(`🛡️ Kill Switch ${newState ? "ENABLED" : "DISABLED"}`);

                    setShowKillSwitchModal(false);
                    killSwitchToggleRef.setFocus();
                  }}
                >
                  <Text x={35} y={20} style={{ fontSize: 24, color: hexColor("#ffffff"), fontWeight: "bold" }}>
                    {pendingKillSwitchState() ? "Enable" : "Disable"}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Show>



        <Show when={deviceInfoFocus()}>
          {/* Jetstream-style label/value list: gray label above white value,
              same language as ContentBlock's Director/Cast columns */}
          <View x={550} y={-20} height={600} width={1300} clipping>
            <Text style={{ fontSize: 40, fontWeight: "bold", color: hexColor("#ffffff") }}>
              Device Information
            </Text>

            <View
              y={90}
              style={{ display: "flex", flexDirection: "column", gap: 32, width: 1200 }}
            >
              <View style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Text style={{ fontSize: 22, color: hexColor("#8E8E93") }}>Device</Text>
                <Text style={{ fontSize: 28, color: hexColor("#ffffff") }}>
                  {(() => {
                    try {
                      const stored = JSON.parse(localStorage.getItem('deviceInfo') || '{}');
                      return stored.model || deviceModel() || "Unknown";
                    } catch {
                      return deviceModel() || "Unknown";
                    }
                  })()} • {(() => {
                    try {
                      const stored = JSON.parse(localStorage.getItem('deviceInfo') || '{}');
                      return stored.generation || "";
                    } catch {
                      return "";
                    }
                  })()}
                </Text>
                <Text style={{ fontSize: 20, color: hexColor("#8E8E93") }}>
                  Tizen {(() => {
                    try {
                      const stored = JSON.parse(localStorage.getItem('deviceInfo') || '{}');
                      return stored.tizenVersion || tizenVersion() || "Unknown";
                    } catch {
                      return tizenVersion() || "Unknown";
                    }
                  })()}
                </Text>
              </View>

              <View style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Text style={{ fontSize: 22, color: hexColor("#8E8E93") }}>Display</Text>
                <Text style={{ fontSize: 28, color: hexColor("#ffffff") }}>
                  {(() => {
                    try {
                      const stored = JSON.parse(localStorage.getItem('deviceInfo') || '{}');
                      return stored.screenSize || screenSize() || "Unknown";
                    } catch {
                      return screenSize() || "Unknown";
                    }
                  })()} • {screenResolution() || "Unknown"}
                </Text>
              </View>

              <View style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Text style={{ fontSize: 22, color: hexColor("#8E8E93") }}>Storage</Text>
                <Text style={{ fontSize: 28, color: hexColor("#ffffff") }}>
                  {storageInfo() || "Unknown"}
                </Text>
              </View>

              <View style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Text style={{ fontSize: 22, color: hexColor("#8E8E93") }}>Network</Text>
                <Text style={{ fontSize: 28, color: hexColor("#ffffff") }}>
                  {networkType() || "Unknown"} Connection
                </Text>
                <Text style={{ fontSize: 18, color: hexColor("#8E8E93") }}>
                  Device ID: {(() => {
                    const duid = deviceDUID();
                    return duid ? `${duid.substring(0, 12)}...` : "Unknown";
                  })()}
                </Text>
              </View>

              <Text style={{ fontSize: 18, color: hexColor("#8E8E93") }}>
                Last Updated: September 13, 2025
              </Text>
            </View>
          </View>
        </Show>

        <Show when={languageFocus()}>
          <LanguagePicker
            onLeftEdge={() => languageRef.setFocus()}
            firstTileRef={(el) => { refLanguage = el; }}
          />
        </Show>
      </View>

      {/* Bottom Info Bar */}
      <View y={930} x={100}>
        <Text fontWeight={'bold'} fontSize={32} color={hexColor("#FFFFFF")}>{day()}</Text>
        <Text fontSize={26} color={hexColor("#a0a1a3")} y={40}>{dateTime()}</Text>
      </View>

      <Text x={1650} fontSize={27} y={950} color={hexColor("#a0a1a3")}>Version {packageJson.version}</Text>
    </View>
  );
};

export default SettingsPanel;